import { bandWidthPercent } from '../sections/_shared/universal.js';
/**
 * Does this page OPEN on a full-bleed visual? — the one fact the header needs to decide whether it wears
 * its normal bar or floats over the image (founder, 2026-09-15: « transparent sur l'accueil, blanc sur la
 * page produit », with ONE header).
 *
 * ## The type, AND the band still bleeding
 *
 * The type comes first: these are the banner sections, the ones that paint an edge-to-edge band. Everything
 * else — rich-text, custom-columns, `main-product` — never is, which is exactly the product page's case: it
 * opens on the buy box, so the header stays a normal white bar there with nothing to configure.
 *
 * But a banner can be pulled IN: the universal `sectionWidth` slider makes the painted band take N% of the
 * page, centred (100% = the edge-to-edge default). At 84% there is white margin on both sides of the image,
 * and a bar floating over that reads as broken — half of it on the photograph, half on the page background.
 * So an inset band is not an opener either. NOTE the difference with the other width control: `width` caps
 * the TEXT COLUMN inside the band and leaves the band itself bleeding, so it has no say here.
 *
 * ## Why the FIRST section only
 *
 * The header floats over what is directly beneath it. A hero in the MIDDLE of a page is scrolled past,
 * under a header that has long since become opaque — it must not change how the top of the page reads.
 * `disabled` sections are skipped: a hidden hero is not on the page.
 */
export const FULL_BLEED_OPENERS = [
    'hero',
    'parallax-hero',
    'slideshow-hero',
    'slideshow',
    'image',
    'video',
    'collage',
    'image-slider',
    // PAS `collection-banner` (retiré le 15/09/2026, fondatrice : « dans la page collection je vois un header
    // transparent, on veut pas »). C'est un BANDEAU DE TITRE — le nom de la collection et sa description sur
    // une bande — pas un héros. Il appartient SOUS la barre, pas derrière elle ; et comme il ouvre chaque
    // page collection, l'y laisser rendait le header transparent sur tout le catalogue.
];
/**
 * `true` when the first ENABLED section of a page body is one of {@link FULL_BLEED_OPENERS}.
 *
 * Hosts call this on the BODY document (chrome already stripped) and pass the answer to the render context
 * as {@link RenderContext.pageOpensOnMedia}; the header reads it there. Treats the input as untrusted —
 * a malformed document (non-array, null section, missing type) answers `false` rather than throwing, the
 * same contract `splitChromeSections` / `hydrateDocument` hold.
 */
export function pageOpensOnMedia(sections) {
    if (!Array.isArray(sections))
        return false;
    const first = sections.find((s) => s && typeof s === 'object' && s.disabled !== true);
    if (!first || !FULL_BLEED_OPENERS.includes(first.type))
        return false;
    // Unset = the schema default = 100 = edge-to-edge, which is what `bandWidthPercent` answers for
    // `undefined`. So an untouched banner is an opener without the document having to say so.
    return bandWidthPercent(first.settings?.sectionWidth) === 100;
}
//# sourceMappingURL=opensOnMedia.js.map